import { vars } from "@pancakeswap/ui/css/vars.css";
import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    background: lightColors.backgroundAlt,
    text: lightColors.text,
    boxShadow: vars.shadows.tooltip
};
export var dark = {
    background: darkColors.backgroundAlt,
    text: darkColors.text,
    boxShadow: vars.shadows.tooltip
};
